<template>
  <div class="solar-energy">
    <h3>Solar Energy</h3>
  </div>
</template>

<script>
export default {
  name: 'SolarEnergy',
}
</script>
